import VideoStreamBindModal from './VideoStreamBindModal';

export default VideoStreamBindModal;
